import decode from 'jwt-decode';
import { API_ROOT } from '../variables/api-config';
import { store } from '../index';
import { setLoading } from '../containers/App/Reducers/actions';

export class BaseService {
    // Initializing important variables
    constructor(domain) {
        this.domain = domain || API_ROOT // API server domain
        this.fetch = this.fetch.bind(this) // React binding stuff
    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from localstorage
        return !!token && !this.isTokenExpired(token) // handwaiving here
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken)
    }

    getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    }


    fetch(url, options, noLoading) {
      if (!noLoading) {
        store.dispatch(setLoading(true));
      }
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }

        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => {
              if (!noLoading) {
                store.dispatch(setLoading(false));
              }
              return response.json();
            })
            .catch(err => {
              store.dispatch(setLoading(false));
            })
    }

    fetchCSV(url, options) {
      store.dispatch(setLoading(true));
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'text/csv',
            'Content-Type': 'application/json'
        }

        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => {
              store.dispatch(setLoading(false));
              return response.blob();
            })
            .catch(err => {
              store.dispatch(setLoading(false));
            })
    }

    _checkStatus(response) {
      // raises an error in case response status is not a success
      if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
         return response
      } else {
         var error = new Error(response.statusText)
         error.response = response
         throw error
      }

    }
}



// WEBPACK FOOTER //
// ./src/services/BaseService.js